import { CountryStateState } from '../../../src/Definitions/CountryState';
export const STORE_NAME = 'dokan/country-state';
export const DEFAULT_STATE: CountryStateState = {
    countries: {},
    isLoading: {},
    errors: {},
};
